// extracted by mini-css-extract-plugin
module.exports = {"brand":"Products_brand__3_UHb","heading":"Products_heading__24wsW","code":"Products_code__B6pY0","description":"Products_description__2RScR"};